import React from 'react';
import RepProfileCallActivities from '$pages/$rep-profile/RepProfileCallActivities';
import {formatDuration} from 'utils/periodAsText';

export default class CoachCallActivity extends React.Component {
  render() {
    const {RepProfilePageStore, UserStore} = this.props;
    const {
      callActivity,
      callDonut,
      callTeamMetrics,
      didCallActivityFetchFail,
      didCallDonutFetchFail,
      didCallTeamMetricsFail,
      isCallActivityFetching,
      isCallDonutFetching,
      isCallTeamMetricsFetching,
    } = RepProfilePageStore;
    const repBeingViewed = UserStore.users.get(this.props.repId);
    const {startDate, endDate, headerStartDate, headerEndDate} = this.props;
    const periodText = formatDuration(headerStartDate, headerEndDate, {
      shouldPluralize: false,
    });
    return (
      <div className="tab-content">
        {didCallActivityFetchFail || didCallDonutFetchFail || didCallTeamMetricsFail ? (
          <p>There was a problem fetching the call activity.</p>
        ) : (
          <RepProfileCallActivities
            rep={repBeingViewed}
            callActivity={callActivity}
            callDonut={callDonut}
            callTeamMetrics={callTeamMetrics}
            isCallActivityLoading={isCallActivityFetching}
            isCallDonutLoading={isCallDonutFetching}
            isCallTeamMetricsLoading={isCallTeamMetricsFetching}
            onSelectRep={this.props.onSelectRep}
            periodText={periodText}
            startDate={startDate}
            endDate={endDate}
            headerStartDate={headerStartDate}
            headerEndDate={headerEndDate}
            location={this.props.location}
            renderTeamAverage={true}
            users={UserStore.users}
          />
        )}
      </div>
    );
  }
}
